module.exports = __webpack_public_path__ + "img/guchebao.86dec915.png";